import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js';

export const StripePromise = loadStripe(
    process.env.NEXT_PUBLIC_STRIPE_PUBLISH_KEY ?? ''
);

export const StripeOptions: StripeElementsOptions = {
    fonts: [
        {
            family: 'helvetica',
            src: 'url(https://assets.therealest.com/helveticaneuemedium-webfont.woff2)',
            weight: '500',
        },
    ],
    appearance: {
        theme: 'stripe',
        variables: {
            fontFamily: 'helvetica',
            spacingGridRow: '25px',
            fontSizeBase: '14px',
            fontSizeLg: '14px',
            fontSize2Xs: '14px',
            fontSize3Xs: '14px',
            fontSizeSm: '14px'
        },
    },
};
